import { up } from 'styled-breakpoints'
import styled from 'styled-components'

import theme from '~/truck/theme'
import { themeGetters } from '~/truck/utils'

const { spacing } = themeGetters

export const Container = styled.div`
  flex-shrink: 0;
  margin-bottom: ${theme.spacing.comfortable}px;

  p:last-child {
    display: none;

    ${up('lg')} {
      display: block;
      margin-top: ${spacing('compact')}px;
    }
  }
`
